<template>
  <div class="container">
    <top-bar @change="onSearch" @searchCompany="onSearchCompany"></top-bar>
    <div class="page-container">
      <router-view class="page-content"></router-view>
    </div>
    <el-dialog
      title="意见反馈"
      :visible.sync="dialogVisible"
      width="524px"
      >
      <el-input
        type="textarea"
        :rows="7"
        placeholder="请把您的问题或者建议反馈给我们 (500字内)"
        v-model="textarea"
        maxlength="500"
        show-word-limit
        > 
      </el-input>
      <div v-show="isShowUpload" class="upload-btn" @click="upload">上传图片</div>
      <el-upload
        v-show="!isShowUpload"
        action="#"
        list-type="picture-card"
        :auto-upload=false
        :on-remove="handleRemove"
        :on-change="handleChange"
        :file-list="fileListData"
        :limit=5
        :on-exceed="handleExceed"
       >
        <i class="el-icon-plus"></i>
      </el-upload>
      <div class="row confirm">
        <div></div>
        <el-button class="confirm-btn" @click="onOkUploadClick" :loading="clickConfirmBtn">确定</el-button>
      </div>
      <div class="row contact-information">
        <div class="contact-word">或者扫描二维码, 和香侬小助手详谈</div>
        <div class="contact-img"></div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import TopBar from '@/components/common/TopBar';
import questionQuery from '@/rest/questionQuery';

export default {
  data() {
    return {
      dialogVisible: false,
      textarea: '',
      isShowUpload: true,
      fileList: [],
      clickConfirmBtn: false,
      fileListData: []
    };
  },
  methods: {
    handleExceed() {
      this.$message.warning('最多可以上传5张图片');
    },
    onOpenFeedbackDialogClick() {
      this.clickConfirmBtn = false;
      this.dialogVisible = true;
      this.isShowUpload = true;
      this.textarea = '';
      this.fileListData = [];
      this.fileList = [];
    },
    handleChange(file, fileList) {
      if (file.size / 1024 / 1024 > 3) {
        this.$message.error('上传图片大小不能超过 3MB!');
        for (let i = 0; i < fileList.length; i++) {
          if (fileList[i] === file) {
            fileList.splice(i, 1);
            break;
          }
        }
      }
      this.fileList = fileList.map(item => {
        return item.raw;
      });
    },
    handleRemove(file, fileList) {
      this.fileList = fileList.map(item => {
        return item.raw;
      });
    },
    onOkUploadClick() {
      if (!this.fileList.length && !this.textarea) {
        this.$message.warning('内容不能为空');
      } else {
        const formData = new FormData();
        for (let i = 0; i < this.fileList.length; i++) {
          const file = `file${i + 1}`;
          formData.append(file, this.fileList[i]);
        }
        formData.append('message', this.textarea);
        formData.append('fileLength', this.fileList.length);
        this.clickConfirmBtn = true;
        questionQuery.feedback(formData).then(() => {
          this.clickConfirmBtn = false;
          this.dialogVisible = false;
          this.isShowUpload = true;
          this.textarea = '';
          this.fileListData = [];
          this.$message({
            message: '提交成功，感谢您的反馈',
            type: 'success'
          });
        });
      }
    },
    upload() {
      this.isShowUpload = !this.isShowUpload;
      document.querySelector('.el-upload').click();
    },
    onSearch(searchText) {
      if (this.$route.path === '/result' && this.$route.query.type === 'perimeter') {
        this.$router.push({
          name: 'result-page',
          query: {
            type: 'perimeter',
            q: searchText
          }
        });
      } else {
        this.$router.push({
          name: 'result-page',
          query: {
            q: searchText
          }
        });
      }
    },
    onSearchCompany(searchText) {
      this.$router.push({
        name: 'search-result-page',
        query: {
          q: searchText
        }
      });
    }
  },
  components: {
    TopBar
  }
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  min-height:100%;
  background-color: #f7f8fc;
}

.feedback {
  position: fixed;
  right: 54px;
  bottom:72px;
  padding: 11px;
  width: 40px;
  height: 40px;
  background-color: #FFFFFF20;
  border-radius: 4px;
  z-index: 1;
  cursor: pointer;
  &:hover {
    background-color: #45a8cc;
  }
  &:active {
    background-color: #368cab;
  }
  .feedback-img {
    width: 18px;
    height: 18px;
    background-image: url("../assets/img/feedback.svg");
    background-size: cover;
  }
}

.page-container {
  padding-top: 60px;
}

.upload-btn {
  height: 44px;
  line-height: 44px;
  margin-bottom:32px;
  background-color: #423f43;
  border-radius: 2px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
}
.confirm {
  margin-bottom: 57px;
  justify-content: space-between;
  .confirm-btn {
    height: 48px;
    width: 115px;
    padding: 0;
    font-size: 16px;
    color: #ffffff;
    background-color: #45a8cc;
    box-shadow: 0px 2px 4px 0px rgba(6, 94, 114, 0.1);
    border-radius: 2px;
    border: none;
    &:hover {
      color: #ffffff;
      background-color: #3cbeed;
    }
    &:focus {
      color: #ffffff;
      background-color: #3cbeed;
    }
    &:active {
      color: #ffffff;
      background-color: #368cab;
    }
  }
}
.contact-information {
  justify-content: space-between;
  .contact-word {
    font-size: 14px;
    color: #727273;
  }
  .contact-img {
    width: 88px;
    height: 88px;
    background-image: url("../assets/img/two-dimension-code.jpeg");
    background-size: cover;
  }
}
/deep/ .el-dialog {
  border-radius: 8px;
  background-color: #333138;
  box-shadow: 0px 29px 50px 0px rgba(5, 69, 92, 0.1); 
  .el-dialog__header {
    padding:20px 32px;
    .el-dialog__title {
      font-size: 20px;
      color: #ffffff;
    }
  }
  .el-dialog__body {
    padding:6px 32px 32px;
    .el-textarea {
      .el-textarea__inner {
        margin-bottom:16px;
        background-color: #2e2c34;
        border-radius: 2px;
        border: solid 1px #585659;
        color: #ffffff;
      }
    }
    .el-upload-list--picture-card .el-upload-list__item {
      width: 80px;
      height: 80px;
      line-height: 80px;
      background-color: #d8d8d8;
      border-radius: 2px;
      border: solid 1px #979797;
    }
    .el-upload--picture-card {
      width: 80px;
      height: 80px;
      line-height: 90px;
      background-color: #333138;
      border-radius: 2px;
      border: solid 1px #585659;
    }
    .is-success {
      width: 80px;
      height: 80px;
      background-color: #d8d8d8;
      border-radius: 2px;
      border: solid 1px #979797;
    }
  }
}
</style>
